import React from 'react';
import Popover from '@material-ui/core/Popover';

type PopoverProps = {
  children: any;
  anchor: React.ReactNode;
  anchorOriginHorizontal?: 'center' | 'left' | 'right' | number;
  anchorOriginVertical?: 'bottom' | 'center' | 'top' | number;
  transformOriginHorizontal?: 'center' | 'left' | 'right' | number;
  transformOriginVertical?: 'bottom' | 'center' | 'top' | number;
};

export default function CustomPopover({
  children,
  anchor,
  anchorOriginHorizontal = 'center',
  anchorOriginVertical = 'bottom',
  transformOriginHorizontal = 'center',
  transformOriginVertical = 'top'
}: PopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <div onClick={handleClick}>
        {anchor}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: anchorOriginVertical,
          horizontal: anchorOriginHorizontal,
        }}
        transformOrigin={{
          vertical: transformOriginVertical,
          horizontal: transformOriginHorizontal,
        }}
      >
        {children(handleClose)}
      </Popover>
    </div>
  );
}
